import React from 'react';

export function DismissIcon() {
    return (
        <svg width="8" height="8" viewBox="0 0 11 10" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.21548 5L10.5817 1.63375C10.7764 1.43906 10.7764 1.12313 10.5817 0.928127L9.79954 0.145939C9.60485 -0.0487482 9.28891 -0.0487482 9.09391 0.145939L5.72798 3.5125L2.36173 0.146252C2.16704 -0.0484356 1.8511 -0.0484356 1.6561 0.146252L0.874226 0.928127C0.679539 1.12281 0.679539 1.43875 0.874226 1.63375L4.24048 5L0.874226 8.36625C0.679539 8.56094 0.679539 8.87687 0.874226 9.07187L1.65641 9.85406C1.8511 10.0487 2.16704 10.0487 2.36204 9.85406L5.72798 6.4875L9.09423 9.85375C9.28891 10.0484 9.60485 10.0484 9.79985 9.85375L10.582 9.07156C10.7767 8.87688 10.7767 8.56094 10.582 8.36594L7.21548 5Z" />
        </svg>
    );
}
